import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Header,
  Icon,
  Message,
  Statistic,
  Table,
  Label,
  Confirm,
} from 'semantic-ui-react';
import { API, showError, showSuccess, isAdmin } from '../../helpers';

const BannedIP = () => {
  const [bannedIPs, setBannedIPs] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [unbanIP, setUnbanIP] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);

  const fetchBannedIPs = async () => {
    setLoading(true);
    try {
      const res = await API.get('/api/ip_ban/');
      const { success, message, data } = res.data;
      if (success) {
        setBannedIPs(data.ips || []);
        setTotalCount(data.total || 0);
      } else {
        showError(message);
      }
    } catch (err) {
      showError('获取封禁列表失败');
    } finally {
      setLoading(false);
    }
  };

  const handleUnban = async () => {
    try {
      const res = await API.post('/api/ip_ban/unban?ip=' + encodeURIComponent(unbanIP));
      const { success, message } = res.data;
      if (success) {
        showSuccess(message);
        fetchBannedIPs();
      } else {
        showError(message);
      }
    } catch (err) {
      showError('解封请求失败');
    }
    setShowConfirm(false);
    setUnbanIP('');
  };

  useEffect(() => {
    fetchBannedIPs();
  }, []);

  if (!isAdmin()) {
    return (
      <Message error>
        <Message.Header>无权限</Message.Header>
        <p>此页面仅管理员可访问</p>
      </Message>
    );
  }

  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header>
            <Header as='h2'>
              <Icon name='shield alternate' />
              <Header.Content>
                封禁IP管理
                <Header.Subheader>连续输错密码3次的IP会被永久封禁</Header.Subheader>
              </Header.Content>
            </Header>
          </Card.Header>

          {/* Total count */}
          <div style={{ margin: '20px 0' }}>
            <Statistic color='red' size='small'>
              <Statistic.Value>{totalCount}</Statistic.Value>
              <Statistic.Label>已封禁IP总数</Statistic.Label>
            </Statistic>
          </div>

          {/* Banned IPs table */}
          <Table celled striped selectable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>IP 地址</Table.HeaderCell>
                <Table.HeaderCell>封禁时间</Table.HeaderCell>
                <Table.HeaderCell>登录尝试次数</Table.HeaderCell>
                <Table.HeaderCell>状态</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>操作</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {bannedIPs.length === 0 ? (
                <Table.Row>
                  <Table.Cell colSpan='5' textAlign='center'>
                    {loading ? '加载中...' : '暂无被封禁的IP'}
                  </Table.Cell>
                </Table.Row>
              ) : (
                bannedIPs.map((item, index) => (
                  <Table.Row key={index} negative>
                    <Table.Cell>
                      <Label basic color='red'>
                        {item.ip}
                      </Label>
                    </Table.Cell>
                    <Table.Cell>{item.ban_time}</Table.Cell>
                    <Table.Cell>
                      <Label color='orange'>
                        {item.total_attempts} 次
                      </Label>
                    </Table.Cell>
                    <Table.Cell>
                      <Label color='red'>已封禁</Label>
                    </Table.Cell>
                    <Table.Cell textAlign='center'>
                      <Button
                        color='green'
                        size='small'
                        onClick={() => {
                          setUnbanIP(item.ip);
                          setShowConfirm(true);
                        }}
                      >
                        <Icon name='unlock' /> 解封
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                ))
              )}
            </Table.Body>
          </Table>

          {/* Instructions */}
          <Message info size='small'>
            <Message.Header>
              <Icon name='info circle' />
              说明
            </Message.Header>
            <Message.List>
              <Message.Item>
                连续输错密码 <strong>3次</strong> 后，该IP将被永久封禁（封禁端口80和443，SSH端口22不受影响）
              </Message.Item>
              <Message.Item>
                封禁后该IP的每一次登录行为都会记录到"登录尝试次数"中
              </Message.Item>
              <Message.Item>
                也可通过SSH登录服务器执行 <code>/opt/one-api/unban.sh &lt;IP地址&gt;</code> 进行解封
              </Message.Item>
            </Message.List>
          </Message>
        </Card.Content>
      </Card>

      {/* Unban confirmation dialog */}
      <Confirm
        open={showConfirm}
        header='确认解封'
        content={`确定要解封 IP ${unbanIP} 吗？解封后该IP可重新登录。`}
        confirmButton='确认解封'
        cancelButton='取消'
        onConfirm={handleUnban}
        onCancel={() => {
          setShowConfirm(false);
          setUnbanIP('');
        }}
      />
    </div>
  );
};

export default BannedIP;
